
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class PriceListDetailsDialog extends Serenity.EntityDialog<PriceListDetailsRow, any> {
        protected getFormKey() { return PriceListDetailsForm.formKey; }
        protected getIdProperty() { return PriceListDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return PriceListDetailsRow.localTextPrefix; }
        protected getService() { return PriceListDetailsService.baseUrl; }
        protected getDeletePermission() { return PriceListDetailsRow.deletePermission; }
        protected getInsertPermission() { return PriceListDetailsRow.insertPermission; }
        protected getUpdatePermission() { return PriceListDetailsRow.updatePermission; }

        protected form = new PriceListDetailsForm(this.idPrefix);
        constructor() {
            super();
            q.setTextRightAlign(this.form.PurStdRate);
            q.setTextRightAlign(this.form.SaleStdRate);
            q.setTextRightAlign(this.form.FromWt);
            q.setTextRightAlign(this.form.ToWt);
        }
    }
}